module.exports = __webpack_public_path__ + "media/images/jumping/jump-m-b18f7211bafb96245970568bbef6a8a3.png";